import { connect } from 'react-redux';

import { actionQuickUpdateRoomStatus } from 'store/location/room/actions';

import CalendarComponent from './CalendarComponent';

const mapStateToProps = (state) => ({
  loadingUpdateRoomStatusList: state.RoomStatusList.loadingUpdateRoomStatusList,
});

const mapDispatchToProps = (dispatch) => ({
  actionUpdateLocation: (payload) => dispatch(actionQuickUpdateRoomStatus(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarComponent);
